import { round } from 'mathjs';
import { SEAT_TYPE_CIRCLE } from '%paysera_seat_selection/js/seatSelection/config/constants';
import rotatePolygon from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/rotatePolygon';
import calculatePolygonFromTable from './calculatePolygonFromTable';

function compileSeatPolygon(seat) {
    if (seat.type === SEAT_TYPE_CIRCLE) {
        let center = { x: 0, y: 0 };
        let points = [];
        const seatSize = seat.compiled.size;

        if (seat.row !== null) {
            const {
                transformation: { translation: seatTranslation }, row: {
                    transformation: { translation: rowTranslation, rotation: rowRotation },
                    sector: { transformation: { translation: sectorTranslation, rotation: sectorRotation } },
                },
            } = seat;
            center = {
                x: seatTranslation.x + rowTranslation.x + sectorTranslation.x - seatSize,
                y: seatTranslation.y + rowTranslation.y + sectorTranslation.y,
            };

            points = [{ x: center.x - seatSize, y: center.y - seatSize }, {
                x: center.x + seatSize, y: center.y - seatSize,
            }, { x: center.x + seatSize, y: center.y + seatSize }, { x: center.x - seatSize, y: center.y + seatSize }];

            if (sectorRotation !== 0) {
                points = rotatePolygon(points, seat.row.sector.compiled.polygon.center, sectorRotation);
                [center] = rotatePolygon([center], seat.row.sector.compiled.polygon.center, sectorRotation);
            }
            if (rowRotation !== 0) {
                points = rotatePolygon(points, seat.row.compiled.polygon.center, rowRotation);
                [center] = rotatePolygon([center], seat.row.compiled.polygon.center, rowRotation);
            }
        }

        if (seat.roundTable !== null) {
            ({ points, center } = calculatePolygonFromTable(seat, 'roundTable', seatSize));
        }
        if (seat.rectangleTable !== null) {
            ({ points, center } = calculatePolygonFromTable(seat, 'rectangleTable', seatSize));
        }

        seat.compiled = {
            ...seat.compiled,
            polygon: {
                center,
                dimensions: {
                    width: round(seatSize, 2) * 2, height: round(seatSize, 2) * 2,
                },
                points,
            },
        };
    }

    return seat;
}

export default compileSeatPolygon;
